import React from 'react';
import { Card } from './ui/card';
import { Button } from './ui/button';
import './ServicesSection.css';

const ServicesSection = ({ services }) => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="servicios" className="services-section">
      <div className="services-container">
        <div className="section-header">
          <h2 className="section-title">Nuestros Servicios</h2>
          <p className="section-description">
            Ofrecemos terapias especializadas e integrales adaptadas a las necesidades únicas de cada niño,
            <br />
            con un enfoque profesional y cercano.
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <Card key={service.id || index} className="service-card">
              <div className="service-image-wrapper">
                <img
                  src={service.image}
                  alt={service.title}
                  className="service-image"
                />
              </div>
              <div className="service-content">
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
                <div className="service-badge">Atención personalizada</div>
              </div>
            </Card>
          ))}
        </div>

        <div className="cta-box">
          <div className="cta-content">
            <h3 className="cta-title">¿No estás seguro qué terapia necesita tu hijo?</h3>
            <p className="cta-description">
              Contáctanos para una evaluación inicial sin compromiso. Te orientaremos sobre el mejor camino a seguir.
            </p>
          </div>
          <Button
            className="cta-button-secondary"
            onClick={() => scrollToSection('contacto')}
          >
            Solicitar Orientación
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
